import HiviewerLoader from "../shared/HiviewerLoader";

const Loader = () => {
  return (
    <div style={{width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <HiviewerLoader />
    </div>
  );
};

export default Loader;
